import { SpendVarianceSkeleton } from '../components/spend/ChartLoading';
import { Breadcrumb } from '../components/ui/Breadcrumb';
import spendStyles from '../components/spend/SpendCharts.module.css';
import page from './Page.module.css';

/** Shown while the lazy-loaded Analysis (`SpendPage`) chunk downloads — mirrors layout so navigation feels instant. */
export function SpendPageFallback() {
  const sk = spendStyles;
  return (
    <div>
      <Breadcrumb items={[{ label: 'Analysis' }]} />
      <div className={page.analysisLayout}>
        <aside className={page.analysisSidebar} aria-hidden>
          <div
            className={page.card}
            style={{ marginBottom: 0 }}
            role="status"
            aria-busy="true"
            aria-label="Loading Model Analyzer sidebar"
          >
            <span
              className={`${sk.skeletonShimmer} ${sk.skeletonBar}`}
              style={{ width: '80%', height: 22, borderRadius: 6, display: 'block', marginBottom: 16 }}
            />
            <span
              className={`${sk.skeletonShimmer} ${sk.skeletonBar}`}
              style={{ width: '100%', height: 40, borderRadius: 8, display: 'block', marginBottom: 12 }}
            />
            <span
              className={`${sk.skeletonShimmer} ${sk.skeletonBar}`}
              style={{ width: '90%', height: 12, display: 'block', marginBottom: 16 }}
            />
            {[1, 2, 3, 4, 5].map((i) => (
              <span
                key={i}
                className={`${sk.skeletonShimmer} ${sk.skeletonBar}`}
                style={{ width: '100%', height: 34, borderRadius: 8, display: 'block', marginBottom: 6 }}
              />
            ))}
          </div>
        </aside>
        <div
          className={page.analysisMain}
          role="status"
          aria-live="polite"
          aria-busy="true"
          aria-label="Loading Analysis workspace"
        >
          <p className={page.muted} style={{ marginBottom: 12 }}>
            Loading workspace…
          </p>
          <SpendVarianceSkeleton caption="Loading charts…" ariaLabel="Loading Analysis charts" />
        </div>
      </div>
    </div>
  );
}
